import { captureException, withScope } from '@sentry/nextjs';

import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

type AxiosErrorCustomConfig = AxiosRequestConfig & {
  isValidate: boolean;
};

const captureClientAxiosError = (error: AxiosError) => {
  const { name, code = '', message = '', config = {}, response = {} } = error;
  const {
    method,
    url,
    params: reqParams,
    data: reqData,
    headers: reqHeaders,
    isValidate = false,
    baseURL,
  } = config as AxiosErrorCustomConfig;
  const { data: resData, status, statusText, headers: resHeaders } = response as AxiosResponse;

  if ((method && method.toUpperCase() === 'HEAD') || isValidate) return;

  withScope(scope => {
    scope.setContext('API Request Detail', {
      method,
      url,
      params: reqParams ?? '-',
      data: JSON.stringify(reqData) ?? '-',
      headers: reqHeaders,
    });

    scope.setContext('API Error Data Detail', {
      code,
      message,
    });

    scope.setContext('API Error Response Detail', {
      status,
      data: JSON.stringify(resData),
      headers: resHeaders,
      statusText,
    });

    const expandedTags = {
      errorType: name,
      requestServerName: baseURL,
      path: url,
      method,
      responseCode: status,
    };

    const getLevel = (status: number) => {
      if (status === 401) return 'info';
      if (status === 403) return 'info';
      if (status === 404) return 'info';
      return 'warning';
    };

    scope.setTags(expandedTags);
    scope.setLevel(getLevel(status));
    captureException(error);
  });
};

export default captureClientAxiosError;
